var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoMembersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8.64257C10.5711 8.64257 12.25 6.96364 12.25 4.89258C12.25 2.82151 10.5711 1.14258 8.5 1.14258C6.42893 1.14258 4.75 2.82151 4.75 4.89258C4.75 6.96364 6.42893 8.64257 8.5 8.64257Z",
    stroke: "#44536D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21.1423H1V19.4756C1 17.4865 1.79018 15.5788 3.1967 14.1723C4.60323 12.7658 6.51088 11.9756 8.50001 11.9756C10.4891 11.9756 12.3968 12.7658 13.8033 14.1723C15.2098 15.5788 16 17.4865 16 19.4756V21.1423Z",
    stroke: "#44536D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1665 1.14258C16.1611 1.14258 17.1149 1.53767 17.8181 2.24093C18.5214 2.94419 18.9165 3.89801 18.9165 4.89258C18.9165 5.88714 18.5214 6.84096 17.8181 7.54422C17.1149 8.24749 16.1611 8.64257 15.1665 8.64257",
    stroke: "#44536D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.833 12.293C19.2527 12.8331 20.475 13.7915 21.3381 15.0415C22.2011 16.2914 22.6643 17.774 22.6663 19.293V21.143H20.1663",
    stroke: "#44536D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoMembersIcon);
export default __webpack_public_path__ + "static/media/two-members-icon.81d83089385774564243951dfaa9e0eb.svg";
export { ForwardRef as ReactComponent };